
/* styles */
require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-2e304393\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../vue-loader/lib/selector?type=styles&index=0!./Circle2.vue")

var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./Circle2.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2e304393\"}!../../../vue-loader/lib/selector?type=template&index=0!./Circle2.vue"),
  /* scopeId */
  "data-v-2e304393",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loading-spinner/src/components/Circle2.vue
// module id = 812
// module chunks = 170